/**
 * Service to help with the external login procedures
 * 
 * @class externalLogin
 */
angular.module('app').service('externalLogin', ['$http', '$location', '$window', '__env', function ($http, $location, $window, __env) {

    /**
     * Calls the login API to generate a nonce value
     * 
     * @function GetNonce
     * @param {string} state - State to pass to the login server
     * @returns {Object} - returns a Http promise
     */
    this.GetNonce = function(state) {
      var url = __env.apiBaseUrl + "/login/external/";
      if (state) {
        url = url + encodeURIComponent(state);
      }

        return this.httpRequest(url, 'get', null, true);
    };

    /**
     * Get the uri to the sso login server
     * 
     * @function getExternalLoginUri
     * @param {string} state - State to send to the login server
     * @param {string} nonce - nonce value to pass to the login server - Should be the value generated by the login API
     * @param {bool} isGoogleEnabled - If Google authentication is enabled
     * @returns {string} - Uri to the login server, with a populated query string
     */
    this.getExternalLoginUri = function(state, nonce, isGoogleEnabled)
    {
        var uri = __env.ssoBaseUrl;
        if (isGoogleEnabled) {
            uri += __env.ssoGooglePath;
        } else {
            uri += __env.ssoOnlyPath;
        }

        var redirectUri = encodeURIComponent($location.absUrl().split('?')[0] + "?");
        uri += '/connect/authorize?acr_values=idp:Google&client_id=implicitclient&response_type=id_token&scope=openid%20email&redirect_uri=' +
            redirectUri +
            '&response_mode=fragment&state=' +
            state +
            '&nonce=' +
            nonce;            

        return uri;
    }

    /**
     * Call the login API to login with a 3rd party token
     * 
     * @function externalLogin
     * @param {string} state - State that was used when generating the nonce value
     * @param {string} token - Token coming from the login server
     * @returns {Object} - Angular Http promise
     */
    this.externalLogin = function(state, token) {

        var url = __env.apiBaseUrl + '/login/external'

        var data = { 'state': state, 'token': token };

        return this.httpRequest(url, 'post', data, true);
    }

    /**
     * Helper function to generate a REST request
     * 
     * @param {string} url - Url to query
     * @param {string} method - Method to use (PUT, POST, ...)
     * @param {Object} data - Object to send as the body of the request
     * @param {bool} withCredentials - Whether we should send credentials (aka cookies) with the call
     * @returns {Object} - Angular HTTP promise
     */
    this.httpRequest = function(url, method, data, withCredentials) {
        return $http({
            withCredentials: withCredentials,
            url: url,
            data: data,
            method: method,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    };

}]);

